// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
import { CmsPhraseFragmentDoc } from '../../fragments/__generated__/CmsPhraseFragment';
export type CmsLocaleInputType =
  | 'ar'
  | 'de'
  | 'en'
  | 'es'
  | 'et'
  | 'fr'
  | 'id'
  | 'ja'
  | 'ko'
  | 'pt'
  | 'ru'
  | 'th'
  | 'tr'
  | 'vi'
  | 'zh';

export type CmsLoyalty__status_Input =
  | 'draft'
  | 'published';

export type CmsLoyalty__status_operator = {
  all?: Array<CmsLoyalty__status_Input | null | undefined> | null | undefined;
  equals?: CmsLoyalty__status_Input | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<CmsLoyalty__status_Input | null | undefined> | null | undefined;
  not_equals?: CmsLoyalty__status_Input | null | undefined;
  not_in?: Array<CmsLoyalty__status_Input | null | undefined> | null | undefined;
};

export type CmsLoyalty_brandSlug_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_brand_operator = {
  all?: Array<any> | null | undefined;
  equals?: any;
  in?: Array<any> | null | undefined;
  not_equals?: any;
  not_in?: Array<any> | null | undefined;
};

export type CmsLoyalty_createdAt_operator = {
  equals?: any;
  exists?: boolean | null | undefined;
  greater_than?: any;
  greater_than_equal?: any;
  less_than?: any;
  less_than_equal?: any;
  like?: any;
  not_equals?: any;
};

export type CmsLoyalty_enabledTabs__faq_operator = {
  equals?: boolean | null | undefined;
  exists?: boolean | null | undefined;
  not_equals?: boolean | null | undefined;
};

export type CmsLoyalty_enabledTabs__history_operator = {
  equals?: boolean | null | undefined;
  exists?: boolean | null | undefined;
  not_equals?: boolean | null | undefined;
};

export type CmsLoyalty_faq__description_operator = {
  all?: Array<any> | null | undefined;
  equals?: any;
  in?: Array<any> | null | undefined;
  not_equals?: any;
  not_in?: Array<any> | null | undefined;
};

export type CmsLoyalty_faq__id_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_faq__title_operator = {
  all?: Array<any> | null | undefined;
  equals?: any;
  in?: Array<any> | null | undefined;
  not_equals?: any;
  not_in?: Array<any> | null | undefined;
};

export type CmsLoyalty_id_operator = {
  equals?: number | null | undefined;
  exists?: boolean | null | undefined;
  greater_than?: number | null | undefined;
  greater_than_equal?: number | null | undefined;
  less_than?: number | null | undefined;
  less_than_equal?: number | null | undefined;
  not_equals?: number | null | undefined;
};

export type CmsLoyalty_links__casino_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_links__sports_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_rewards__color_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_rewards__howItWorks_operator = {
  all?: Array<any> | null | undefined;
  equals?: any;
  exists?: boolean | null | undefined;
  in?: Array<any> | null | undefined;
  not_equals?: any;
  not_in?: Array<any> | null | undefined;
};

export type CmsLoyalty_rewards__icon_operator = {
  all?: Array<any> | null | undefined;
  equals?: any;
  exists?: boolean | null | undefined;
  in?: Array<any> | null | undefined;
  not_equals?: any;
  not_in?: Array<any> | null | undefined;
};

export type CmsLoyalty_rewards__id_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_rewards__name_operator = {
  all?: Array<any> | null | undefined;
  equals?: any;
  in?: Array<any> | null | undefined;
  not_equals?: any;
  not_in?: Array<any> | null | undefined;
};

export type CmsLoyalty_rewards__slug_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_tiers__badgeDark_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_tiers__badgeLight_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_tiers__bar_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_tiers__base_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_tiers__body_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_tiers__id_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_tiers__levels__id_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_tiers__levels__loyaltyLevelId_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_tiers__levels__name_operator = {
  all?: Array<any> | null | undefined;
  equals?: any;
  in?: Array<any> | null | undefined;
  not_equals?: any;
  not_in?: Array<any> | null | undefined;
};

export type CmsLoyalty_tiers__loyaltyTierId_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_tiers__name_operator = {
  all?: Array<any> | null | undefined;
  equals?: any;
  in?: Array<any> | null | undefined;
  not_equals?: any;
  not_in?: Array<any> | null | undefined;
};

export type CmsLoyalty_tiers__rewards_operator = {
  contains?: any;
  equals?: any;
  exists?: boolean | null | undefined;
  intersects?: any;
  like?: any;
  not_equals?: any;
  within?: any;
};

export type CmsLoyalty_tiers__sheen_operator = {
  all?: Array<string | null | undefined> | null | undefined;
  contains?: string | null | undefined;
  equals?: string | null | undefined;
  exists?: boolean | null | undefined;
  in?: Array<string | null | undefined> | null | undefined;
  like?: string | null | undefined;
  not_equals?: string | null | undefined;
  not_in?: Array<string | null | undefined> | null | undefined;
};

export type CmsLoyalty_updatedAt_operator = {
  equals?: any;
  exists?: boolean | null | undefined;
  greater_than?: any;
  greater_than_equal?: any;
  less_than?: any;
  less_than_equal?: any;
  like?: any;
  not_equals?: any;
};

export type CmsLoyalty_where = {
  AND?: Array<CmsLoyalty_where_and | null | undefined> | null | undefined;
  OR?: Array<CmsLoyalty_where_or | null | undefined> | null | undefined;
  _status?: CmsLoyalty__status_operator | null | undefined;
  brand?: CmsLoyalty_brand_operator | null | undefined;
  brandSlug?: CmsLoyalty_brandSlug_operator | null | undefined;
  createdAt?: CmsLoyalty_createdAt_operator | null | undefined;
  enabledTabs__faq?: CmsLoyalty_enabledTabs__faq_operator | null | undefined;
  enabledTabs__history?: CmsLoyalty_enabledTabs__history_operator | null | undefined;
  faq__description?: CmsLoyalty_faq__description_operator | null | undefined;
  faq__id?: CmsLoyalty_faq__id_operator | null | undefined;
  faq__title?: CmsLoyalty_faq__title_operator | null | undefined;
  id?: CmsLoyalty_id_operator | null | undefined;
  links__casino?: CmsLoyalty_links__casino_operator | null | undefined;
  links__sports?: CmsLoyalty_links__sports_operator | null | undefined;
  rewards__color?: CmsLoyalty_rewards__color_operator | null | undefined;
  rewards__howItWorks?: CmsLoyalty_rewards__howItWorks_operator | null | undefined;
  rewards__icon?: CmsLoyalty_rewards__icon_operator | null | undefined;
  rewards__id?: CmsLoyalty_rewards__id_operator | null | undefined;
  rewards__name?: CmsLoyalty_rewards__name_operator | null | undefined;
  rewards__slug?: CmsLoyalty_rewards__slug_operator | null | undefined;
  tiers__badgeDark?: CmsLoyalty_tiers__badgeDark_operator | null | undefined;
  tiers__badgeLight?: CmsLoyalty_tiers__badgeLight_operator | null | undefined;
  tiers__bar?: CmsLoyalty_tiers__bar_operator | null | undefined;
  tiers__base?: CmsLoyalty_tiers__base_operator | null | undefined;
  tiers__body?: CmsLoyalty_tiers__body_operator | null | undefined;
  tiers__id?: CmsLoyalty_tiers__id_operator | null | undefined;
  tiers__levels__id?: CmsLoyalty_tiers__levels__id_operator | null | undefined;
  tiers__levels__loyaltyLevelId?: CmsLoyalty_tiers__levels__loyaltyLevelId_operator | null | undefined;
  tiers__levels__name?: CmsLoyalty_tiers__levels__name_operator | null | undefined;
  tiers__loyaltyTierId?: CmsLoyalty_tiers__loyaltyTierId_operator | null | undefined;
  tiers__name?: CmsLoyalty_tiers__name_operator | null | undefined;
  tiers__rewards?: CmsLoyalty_tiers__rewards_operator | null | undefined;
  tiers__sheen?: CmsLoyalty_tiers__sheen_operator | null | undefined;
  updatedAt?: CmsLoyalty_updatedAt_operator | null | undefined;
};

export type CmsLoyalty_where_and = {
  AND?: Array<CmsLoyalty_where_and | null | undefined> | null | undefined;
  OR?: Array<CmsLoyalty_where_or | null | undefined> | null | undefined;
  _status?: CmsLoyalty__status_operator | null | undefined;
  brand?: CmsLoyalty_brand_operator | null | undefined;
  brandSlug?: CmsLoyalty_brandSlug_operator | null | undefined;
  createdAt?: CmsLoyalty_createdAt_operator | null | undefined;
  enabledTabs__faq?: CmsLoyalty_enabledTabs__faq_operator | null | undefined;
  enabledTabs__history?: CmsLoyalty_enabledTabs__history_operator | null | undefined;
  faq__description?: CmsLoyalty_faq__description_operator | null | undefined;
  faq__id?: CmsLoyalty_faq__id_operator | null | undefined;
  faq__title?: CmsLoyalty_faq__title_operator | null | undefined;
  id?: CmsLoyalty_id_operator | null | undefined;
  links__casino?: CmsLoyalty_links__casino_operator | null | undefined;
  links__sports?: CmsLoyalty_links__sports_operator | null | undefined;
  rewards__color?: CmsLoyalty_rewards__color_operator | null | undefined;
  rewards__howItWorks?: CmsLoyalty_rewards__howItWorks_operator | null | undefined;
  rewards__icon?: CmsLoyalty_rewards__icon_operator | null | undefined;
  rewards__id?: CmsLoyalty_rewards__id_operator | null | undefined;
  rewards__name?: CmsLoyalty_rewards__name_operator | null | undefined;
  rewards__slug?: CmsLoyalty_rewards__slug_operator | null | undefined;
  tiers__badgeDark?: CmsLoyalty_tiers__badgeDark_operator | null | undefined;
  tiers__badgeLight?: CmsLoyalty_tiers__badgeLight_operator | null | undefined;
  tiers__bar?: CmsLoyalty_tiers__bar_operator | null | undefined;
  tiers__base?: CmsLoyalty_tiers__base_operator | null | undefined;
  tiers__body?: CmsLoyalty_tiers__body_operator | null | undefined;
  tiers__id?: CmsLoyalty_tiers__id_operator | null | undefined;
  tiers__levels__id?: CmsLoyalty_tiers__levels__id_operator | null | undefined;
  tiers__levels__loyaltyLevelId?: CmsLoyalty_tiers__levels__loyaltyLevelId_operator | null | undefined;
  tiers__levels__name?: CmsLoyalty_tiers__levels__name_operator | null | undefined;
  tiers__loyaltyTierId?: CmsLoyalty_tiers__loyaltyTierId_operator | null | undefined;
  tiers__name?: CmsLoyalty_tiers__name_operator | null | undefined;
  tiers__rewards?: CmsLoyalty_tiers__rewards_operator | null | undefined;
  tiers__sheen?: CmsLoyalty_tiers__sheen_operator | null | undefined;
  updatedAt?: CmsLoyalty_updatedAt_operator | null | undefined;
};

export type CmsLoyalty_where_or = {
  AND?: Array<CmsLoyalty_where_and | null | undefined> | null | undefined;
  OR?: Array<CmsLoyalty_where_or | null | undefined> | null | undefined;
  _status?: CmsLoyalty__status_operator | null | undefined;
  brand?: CmsLoyalty_brand_operator | null | undefined;
  brandSlug?: CmsLoyalty_brandSlug_operator | null | undefined;
  createdAt?: CmsLoyalty_createdAt_operator | null | undefined;
  enabledTabs__faq?: CmsLoyalty_enabledTabs__faq_operator | null | undefined;
  enabledTabs__history?: CmsLoyalty_enabledTabs__history_operator | null | undefined;
  faq__description?: CmsLoyalty_faq__description_operator | null | undefined;
  faq__id?: CmsLoyalty_faq__id_operator | null | undefined;
  faq__title?: CmsLoyalty_faq__title_operator | null | undefined;
  id?: CmsLoyalty_id_operator | null | undefined;
  links__casino?: CmsLoyalty_links__casino_operator | null | undefined;
  links__sports?: CmsLoyalty_links__sports_operator | null | undefined;
  rewards__color?: CmsLoyalty_rewards__color_operator | null | undefined;
  rewards__howItWorks?: CmsLoyalty_rewards__howItWorks_operator | null | undefined;
  rewards__icon?: CmsLoyalty_rewards__icon_operator | null | undefined;
  rewards__id?: CmsLoyalty_rewards__id_operator | null | undefined;
  rewards__name?: CmsLoyalty_rewards__name_operator | null | undefined;
  rewards__slug?: CmsLoyalty_rewards__slug_operator | null | undefined;
  tiers__badgeDark?: CmsLoyalty_tiers__badgeDark_operator | null | undefined;
  tiers__badgeLight?: CmsLoyalty_tiers__badgeLight_operator | null | undefined;
  tiers__bar?: CmsLoyalty_tiers__bar_operator | null | undefined;
  tiers__base?: CmsLoyalty_tiers__base_operator | null | undefined;
  tiers__body?: CmsLoyalty_tiers__body_operator | null | undefined;
  tiers__id?: CmsLoyalty_tiers__id_operator | null | undefined;
  tiers__levels__id?: CmsLoyalty_tiers__levels__id_operator | null | undefined;
  tiers__levels__loyaltyLevelId?: CmsLoyalty_tiers__levels__loyaltyLevelId_operator | null | undefined;
  tiers__levels__name?: CmsLoyalty_tiers__levels__name_operator | null | undefined;
  tiers__loyaltyTierId?: CmsLoyalty_tiers__loyaltyTierId_operator | null | undefined;
  tiers__name?: CmsLoyalty_tiers__name_operator | null | undefined;
  tiers__rewards?: CmsLoyalty_tiers__rewards_operator | null | undefined;
  tiers__sheen?: CmsLoyalty_tiers__sheen_operator | null | undefined;
  updatedAt?: CmsLoyalty_updatedAt_operator | null | undefined;
};

export type RewardCenterFaqQueryVariables = Exact<{
  locale?: Types.CmsLocaleInputType | null | undefined;
  where?: Types.CmsLoyalty_where | null | undefined;
}>;


export type RewardCenterFaqQuery = { cms: { Loyalties: { docs: Array<{ faq: Array<{ id: string | undefined, title: { key: string, value: string | undefined, brandOverwrites: Array<{ value: string | undefined, brand: { slug: string } | undefined }> | undefined } | undefined, description: { key: string, value: string | undefined, brandOverwrites: Array<{ value: string | undefined, brand: { slug: string } | undefined }> | undefined } | undefined }> | undefined }> } | undefined } | undefined };


export const RewardCenterFaqQueryDocument = gql`
    query RewardCenterFaqQuery($locale: CmsLocaleInputType, $where: CmsLoyalty_where) {
  cms {
    Loyalties(locale: $locale, where: $where, limit: 1) {
      docs {
        faq {
          id
          title {
            ...CmsPhraseFragment
          }
          description {
            ...CmsPhraseFragment
          }
        }
      }
    }
  }
}
    ${CmsPhraseFragmentDoc}`;